import React from 'react';
import { useTranslation } from 'react-i18next';

const RequestField = (props) => {
  const { tLabel, required, tHelper, tError, hasError, children } = props;
  const { t } = useTranslation();

  return (
    <div className="request-field">
      {tLabel && (
        <label className="request-field-label">
          {t(tLabel)}
          {required && <span className="request-field-required">*</span>}
        </label>
      )}

      {children}

      {hasError && tError ? (
        <p className="request-field-error">{t(tError)}</p>
      ) : (
        tHelper && <p className="request-field-helper">{t(tHelper)}</p>
      )}
    </div>
  );
};

export default RequestField;
